import hunt from "../../Assets/hunt.jpg";
import gssoc from "../../Assets/gssoc.jpg";
import imc from "../../Assets/imc.jpg";
import lt from "../../Assets/lt.jpg";
import era from "../../Assets/era.png";
import iips from "../../Assets/iips.png";
import hack from "../../Assets/hack.png";
import cloud from "../../Assets/cloud.png";
import vozi from "../../Assets/vozi.png";
import outlier from "../../Assets/outlier.jpg"
const experiences = [
  {
    id: 0,
    img: vozi,
    role: "Software Engineering Intern",
    company: "Vozi (Remote)",
    date: "Jan 2025 - July 2025",
    desc: "Working as a full-stack developer at Vozi, building and maintaining scalable web applications using React, Next.js, TypeScript, and integrating RESTful APIs for seamless user experience.",
    skills: [
      "React.js",
      "Next.js",
      "TypeScript",
      "Node.js",
      "MongoDB",
      "REST APIs"
    ],
  },
   {
    id: 1,
    img: outlier,
    role: "Freelancer",
    company: "Outlier (Remote)",
    date: "April 2025 - June 2025",
    desc: "Refined AI-generated code to enhance performance and UI quality. Currently working as a Reviewer, responsible for evaluating and validating frontend implementations by peers. Contributed to AI-assisted development workflows with a strong focus on usability, maintainability, and performance optimization. ",
    skills: [
      "React.js",
      "Next.js",
      "TypeScript",
      "tailwindcss",
      "communication",
    ],
  },
  {
    id: 2,
    img: cloud,
    role: "Google Cloud Arcade Facilitator",
    company: "Google Cloud",
    date: "July 2024 - Sept 2024",
    desc: "I was selected as a facilitator in Google Cloud Arcade Facilitator'24 program and under this program I achieved 1st milestone and helped over 300+ students start their Google Cloud journey.",
    skills: [
      "Google Cloud",
      "Leadership",
      "Community Management"
    ],
  },
  {
    id: 3,
    img: gssoc,
    role: "Open Source Contributor",
    company: "GirlScript Summer of Code",
    date: "May 2024",
    desc: "Contributing to different open-source projects and learning from industry experts.",
    skills: [
      "Open Source",
      "Project Management",
      "Real Time Collaboration"
    ],
  },
  {
    id: 4,
    img: era,
    role: "Introduction to Data Analysis Course",
    company: "Coursera",
    date: "April 2024 - May 2024",
    desc: "Completed comprehensive Introduction to Data Analysis course covering fundamental concepts. Applied learned concepts through worksheets.",
    skills: [
      "Excel",
      "R",
      "SQL"
    ],
  },
  {
    id: 5,
    img: lt,
    role: "Problem Solver",
    company: "Leetcode",
    date: "Jan 2024",
    desc: "Solving questions on Leetcode platform to enhance my problem-solving skills, completing Data Structures and Algorithms.",
    skills: [
      "Problem Solving",
      "DSA",
      "Algorithms"
    ],
  },
  {
    id: 6,
    img: imc,
    role: "Intern",
    company: "Indore Municipal Corporation",
    date: "June 2023 - Sept 2023",
    desc: "Gained knowledge about how government authorities work. Developed soft skills and worked on a project during a three-month internship at IMC Indore.",
    skills: [
      "Communication Skills",
      "Excel"
    ],
  },
  {
    id: 7,
    img: iips,
    role: "Workshop on Internet of Things",
    company: "IIPS and Upsys Solution",
    date: "Feb 2024",
    desc: "Gained knowledge about IoT, its components, sensors, actuators, and more. The 17-day workshop concluded with developing an IoT project named 'Digilock'.",
    skills: [
      "Sensors",
      "Arduino",
      "Internet of Things"
    ],
  },
  {
    id: 8,
    img: hack,
    role: "5 ⭐ and Certifications on Hackerrank",
    company: "Hackerrank",
    date: "May 2023",
    desc: "Achieved 5 ⭐ in Java on Hackerrank platform, received an intermediate certificate for MySQL, and earned a badge for Problem Solving.",
    skills: [
      "Java",
      "Problem Solving",
      "MySQL"
    ],
  },
  {
    id: 9,
    img: hunt,
    role: "Hackhive Hackathon (Team Leader)",
    company: "Techhunterssss",
    date: "Mar 2024",
    desc: "Led a team in my first hackathon, developing a web app using HTML, CSS, Tailwind, and MongoDB for backend functionality.",
    skills: [
      "React",
      "MongoDB",
      "Node.js",
      "TailwindCSS",
      "Postman"
    ],
  },
];

export { experiences };
